import(/* webpackMode: "eager", webpackExports: ["VideoConferenceClientImpl"] */ "/app/app/[token]/VideoConferenceClientImpl.tsx");
